var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9132 9.95654H10.4349C10.0507 9.95654 9.73926 10.268 9.73926 10.6522V14.1305C9.73926 14.5147 10.0507 14.8261 10.4349 14.8261H13.9132C14.2974 14.8261 14.6088 14.5147 14.6088 14.1305V10.6522C14.6088 10.268 14.2974 9.95654 13.9132 9.95654Z",
    fill: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2174 17.826H17.7391C17.3549 17.826 17.0435 18.1375 17.0435 18.5217V22C17.0435 22.3842 17.3549 22.6956 17.7391 22.6956H21.2174C21.6016 22.6956 21.913 22.3842 21.913 22V18.5217C21.913 18.1375 21.6016 17.826 21.2174 17.826Z",
    fill: "#F1935C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9131 17.826H2.60874C2.22454 17.826 1.91309 18.1375 1.91309 18.5217V22C1.91309 22.3842 2.22454 22.6956 2.60874 22.6956H13.9131C14.2973 22.6956 14.6087 22.3842 14.6087 22V18.5217C14.6087 18.1375 14.2973 17.826 13.9131 17.826Z",
    fill: "#F1935C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.087 2.08691H2.60874C2.22454 2.08691 1.91309 2.39837 1.91309 2.78257V6.26083C1.91309 6.64503 2.22454 6.95648 2.60874 6.95648H6.087C6.4712 6.95648 6.78265 6.64503 6.78265 6.26083V2.78257C6.78265 2.39837 6.4712 2.08691 6.087 2.08691Z",
    fill: "#F1935C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.087 9.95654H2.60874C2.22454 9.95654 1.91309 10.268 1.91309 10.6522V14.1305C1.91309 14.5147 2.22454 14.8261 2.60874 14.8261H6.087C6.4712 14.8261 6.78265 14.5147 6.78265 14.1305V10.6522C6.78265 10.268 6.4712 9.95654 6.087 9.95654Z",
    fill: "#F1935C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9132 2.08691H10.4349C10.0507 2.08691 9.73926 2.39837 9.73926 2.78257V6.26083C9.73926 6.64503 10.0507 6.95648 10.4349 6.95648H13.9132C14.2974 6.95648 14.6088 6.64503 14.6088 6.26083V2.78257C14.6088 2.39837 14.2974 2.08691 13.9132 2.08691Z",
    fill: "#F1935C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2174 9.95654H17.7391C17.3549 9.95654 17.0435 10.268 17.0435 10.6522V14.1305C17.0435 14.5147 17.3549 14.8261 17.7391 14.8261H21.2174C21.6016 14.8261 21.913 14.5147 21.913 14.1305V10.6522C21.913 10.268 21.6016 9.95654 21.2174 9.95654Z",
    fill: "#F1935C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.7391 2.58691H21.2174C21.3254 2.58691 21.413 2.67451 21.413 2.78257V6.26083C21.413 6.36888 21.3254 6.45648 21.2174 6.45648H17.7391C17.6311 6.45648 17.5435 6.36888 17.5435 6.26083V2.78257C17.5435 2.67451 17.6311 2.58691 17.7391 2.58691Z",
    stroke: "#F1935C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSelected);
export default __webpack_public_path__ + "static/media/dashboard-selected.a590357673efb2520f96ffdf2614a595.svg";
export { ForwardRef as ReactComponent };